import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaBook, FaChartLine, FaMoneyBillWave, FaUsers, FaChartPie, FaCertificate, FaHandsHelping,FaQuoteLeft, FaArrowRight, FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";
import CourseWealth from '../../Assets/Financial-Courses-Wealth-Management.png';

import Calculator from '../../Components/Calculator/Calculator';

const Home = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  
  

const handleScroll = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

  const testimonials = [
    {
      text: "The stock market course completely transformed my understanding of investing. I now confidently manage my own portfolio with profits up 37% in just 6 months!",
      author: "Rohan Sharma",
      role: "Former Student, Now Active Trader"
    },
    {
      text: "I started my mutual fund investment through Karikar EduWealth, and the personalized guidance has been exceptional. My portfolio has grown steadily even during market fluctuations.",
      author: "Priya Mehta",
      role: "Long-term Investor"
    },
    {
      text: "As a complete beginner, I was intimidated by financial jargon. Their courses broke down complex concepts into digestible lessons. Now I'm helping my family make better money decisions too!",
      author: "Arjun Patel",
      role: "Financial Education Student"
    }
  ];

  // Rotate testimonials automatically
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };




  return (
    <div className="w-full overflow-hidden">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#02ca02] to-[#02a102] text-white py-16 md:py-24 lg:py-28">
        <div className="container mx-auto px-4 md:px-6 flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <motion.div 
            className="md:w-1/2 text-center md:text-left"
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.7 }}
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
              Master Your Financial Future
            </h1>
            <p className="text-lg md:text-xl mb-8 max-w-xl mx-auto md:mx-0">
              Expert-led financial education and trusted investment solutions to help you build lasting wealth
            </p>
            <div className="flex flex-col sm:flex-row justify-center md:justify-start gap-4">
              <Link to='/courses' onClick={handleScroll}>
              <motion.button 
                className="bg-white text-[#02ca02] px-6 py-3 md:px-8 md:py-4 rounded-lg font-semibold hover:bg-gray-100 transition shadow-md hover:shadow-lg flex items-center justify-center"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Explore Courses <FaArrowRight className="ml-2" />
              </motion.button>
              </Link>
              <Link to='/mutual-funds' onClick={handleScroll}>
              <motion.button 
                className="bg-[#fe0000] text-white px-6 py-3 md:px-8 md:py-4 rounded-lg font-semibold hover:bg-[#e00000] transition shadow-md hover:shadow-lg flex items-center justify-center"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Start Investing <FaArrowRight className="ml-2" />
              </motion.button></Link>
            </div>
          </motion.div>
          <motion.div 
            className="md:w-1/2"
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            <img 
              src={CourseWealth}
              alt="Financial Education" 
              className="rounded-xl shadow-2xl w-full max-w-md mx-auto"
            />
          </motion.div>
        </div>
      </section>

{/* Financial Calculator*/}
          <Calculator />

      {/* Services Snapshot */}
      <section className="py-16">
        <div className="container mx-auto px-4 md:px-6">
          <motion.h2 
            className="text-3xl font-bold text-center mb-4"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            What We Offer
          </motion.h2>
          <div className="w-20 h-1 bg-[#fe0000] mx-auto mb-12"></div>
          <motion.div 
            className="grid md:grid-cols-2 gap-8 lg:gap-12 max-w-5xl mx-auto"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <motion.div 
              className="bg-white p-6 md:p-8 rounded-xl shadow-md hover:shadow-lg transition border-l-4 border-[#02ca02]"
              variants={itemVariants}
            >
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-[#02ca02] bg-opacity-20 rounded-full flex items-center justify-center text-[#02ca02] mr-4">
                  <FaBook className="text-xl" />
                </div>
                <h3 className="text-2xl font-semibold text-[#02ca02]">Financial Education</h3>
              </div>
              <p className="text-gray-600 mb-4">
                Comprehensive courses designed by industry experts to help you understand markets, analysis techniques, and wealth-building strategies.
              </p>
              <ul className="space-y-2 mb-6">
                {["Stock Market Fundamentals", "Technical Analysis", "Fundamental Analysis", "Risk Management", "Trading Psychology"].map((item, i) => (
                  <li key={i} className="flex items-start">
                    <FaCheck className="h-5 w-5 text-[#02ca02] mr-2 mt-0.5" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <button className="text-[#02ca02] font-semibold hover:underline flex items-center">
                Explore Courses
                <FaArrowRight className="w-4 h-4 ml-1" />
              </button>
            </motion.div>
            
            <motion.div 
              className="bg-white p-6 md:p-8 rounded-xl shadow-md hover:shadow-lg transition border-l-4 border-[#fe0000]"
              variants={itemVariants}
            >
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-[#fe0000] bg-opacity-20 rounded-full flex items-center justify-center text-[#fe0000] mr-4">
                  <FaChartLine className="text-xl" />
                </div>
                <h3 className="text-2xl font-semibold text-[#fe0000]">Investment Solutions</h3>
              </div>
              <p className="text-gray-600 mb-4">
                Personalized investment guidance and mutual fund solutions to help you grow your wealth with confidence and security.
              </p>
              <ul className="space-y-2 mb-6">
                {["Portfolio Management", "Mutual Fund Advisory", "Goal-Based Planning", "Retirement Planning", "Tax Efficiency"].map((item, i) => (
                  <li key={i} className="flex items-start">
                    <FaCheck className="h-5 w-5 text-[#fe0000] mr-2 mt-0.5" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <button className="text-[#fe0000] font-semibold hover:underline flex items-center">
                Explore Investments
                <FaArrowRight className="w-4 h-4 ml-1" />
              </button>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Featured Courses */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 md:px-6">
          <motion.h2 
            className="text-3xl font-bold text-center mb-4"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Featured Courses
          </motion.h2>
          <div className="w-20 h-1 bg-[#02ca02] mx-auto mb-12"></div>
          <motion.div 
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {[
              {
                title: "Career Guide To Financial Markets",
                description: "Comprehensive program covering equity markets, derivatives, and financial instruments for career advancement",
                level: "Beginner to Advanced",
                duration: "8 weeks",
                icon: <FaChartPie className="text-2xl" />
              },
              {
                title: "Technical Analysis Mastery",
                description: "Learn chart patterns, indicators, and trading strategies used by professional traders",
                level: "Intermediate",
                duration: "6 weeks",
                icon: <FaChartLine className="text-2xl" />
              },
              {
                title: "Wealth Management & Mutual Funds",
                description: "Master portfolio construction, risk assessment, and long-term wealth building strategies",
                level: "All Levels",
                duration: "4 weeks",
                icon: <FaMoneyBillWave className="text-2xl" />
              }
            ].map((course, index) => (
              <motion.div
                key={index}
                className="bg-white shadow-md rounded-xl overflow-hidden hover:shadow-lg transition"
                variants={itemVariants}
                whileHover={{ y: -5 }}
              >
                <div className="h-40 bg-gray-100 flex items-center justify-center">
                  <div className="text-center">
                    <div className="w-12 h-12 bg-[#02ca02] rounded-full flex items-center justify-center text-white mx-auto mb-2">
                      {course.icon}
                    </div>
                    <p className="text-sm text-gray-500">Course {index + 1}</p>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold mb-3">{course.title}</h3>
                  <p className="text-gray-600 mb-4">{course.description}</p>
                  <div className="flex justify-between text-sm text-gray-500 mb-5">
                    <span>{course.level}</span>
                    <span>{course.duration}</span>
                  </div>
                  <button className="w-full bg-[#02ca02] text-white py-2 rounded-lg hover:bg-[#028a02] transition flex items-center justify-center">
                    Learn More <FaArrowRight className="ml-2" />
                  </button>
                </div>
              </motion.div>
            ))}
          </motion.div>
          <motion.div 
            className="text-center mt-12"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <Link to='/courses' onClick={handleScroll}><button className="bg-[#fe0000] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#e00000] transition shadow-md">
              View All Courses
            </button></Link>
          </motion.div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16">
        <div className="container mx-auto px-4 md:px-6 text-center">
          <motion.h2 
            className="text-3xl font-bold mb-4"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Why Choose Karikar EduWealth?
          </motion.h2>
          <div className="w-20 h-1 bg-[#fe0000] mx-auto mb-12"></div>
          <motion.div 
            className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {[
              { 
                title: "Learn from Industry Veterans", 
                desc: "Our instructors have 15+ years of experience in financial markets and wealth management",
                icon: <FaUsers className="text-2xl" />
              },
              { 
                title: "Practical Learning Approach", 
                desc: "Real-world case studies, live market sessions, and hands-on projects",
                icon: <FaCertificate className="text-2xl" />
              },
              { 
                title: "Unbiased Financial Advice", 
                desc: "SEBI-registered advisors providing recommendations in your best interest",
                icon: <FaHandsHelping className="text-2xl" />
              },
              { 
                title: "Post-Course Support", 
                desc: "Lifetime access to updated materials and community of investors",
                icon: <FaHandsHelping className="text-2xl" />
              },
            ].map((item, idx) => (
              <motion.div
                key={idx}
                className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition border-t-4 border-[#02ca02]"
                variants={itemVariants}
                whileHover={{ y: -5 }}
              >
                <div className="w-14 h-14 bg-[#02ca02] bg-opacity-10 rounded-full flex items-center justify-center text-[#02ca02] mx-auto mb-4">
                  {item.icon}
                </div>
                <h3 className="text-xl font-semibold mb-3">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gradient-to-r from-[#02ca02] to-[#02a102] text-white">
        <div className="container mx-auto px-4 md:px-6">
          <motion.div 
            className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 text-center"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {[
              { value: "5000+", label: "Students Trained" },
              { value: "₹50Cr+", label: "Assets Managed" },
              { value: "98%", label: "Satisfaction Rate" },
              { value: "15+", label: "Years Experience" }
            ].map((stat, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                whileHover={{ scale: 1.05 }}
              >
                <div className="text-3xl md:text-4xl lg:text-5xl font-bold mb-2">{stat.value}</div>
                <div className="text-sm uppercase tracking-wider">{stat.label}</div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 md:px-6 text-center">
          <motion.h2 
            className="text-3xl font-bold mb-4"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Hear From Our Community
          </motion.h2>
          <div className="w-20 h-1 bg-[#02ca02] mx-auto mb-12"></div>
          
          <div className="max-w-3xl mx-auto relative">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentTestimonial}
                className="bg-white shadow-xl rounded-2xl p-8 md:p-12 relative"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
              >
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-[#fe0000] rounded-full flex items-center justify-center text-white text-2xl">
                  <FaQuoteLeft />
                </div>
                <p className="text-gray-700 text-lg italic mb-6 pt-4">
                  "{testimonials[currentTestimonial].text}"
                </p>
                <h4 className="font-semibold text-xl">{testimonials[currentTestimonial].author}</h4>
                <p className="text-gray-500">{testimonials[currentTestimonial].role}</p>
              </motion.div>
            </AnimatePresence>
            
            <div className="flex justify-center mt-8 space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  className={`w-3 h-3 rounded-full ${currentTestimonial === index ? 'bg-[#02ca02]' : 'bg-gray-300'}`}
                  onClick={() => setCurrentTestimonial(index)}
                  aria-label={`View testimonial ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-gradient-to-r from-[#02ca02] to-[#02a102] text-white text-center">
        <div className="container mx-auto px-4 md:px-6">
          <motion.h2 
            className="text-3xl md:text-4xl font-bold mb-6"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Start Your Financial Journey Today
          </motion.h2>
          <motion.p 
            className="text-xl max-w-2xl mx-auto mb-10 opacity-90"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            Join thousands of students and investors who have transformed their financial future with Karikar EduWealth
          </motion.p>
          <motion.div 
            className="flex flex-col sm:flex-row justify-center gap-4"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <Link to='/courses' onClick={handleScroll}>
            <motion.button 
              className="bg-white text-[#02ca02] px-6 py-3 md:px-8 md:py-4 rounded-lg font-semibold hover:bg-gray-100 transition shadow-md hover:shadow-lg flex items-center justify-center"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              View All Courses <FaArrowRight className="ml-2" />
            </motion.button>
            </Link>
            <Link to='/contact' onClick={handleScroll}>
            <motion.button 
              className="bg-[#fe0000] text-white px-6 py-3 md:px-8 md:py-4 rounded-lg font-semibold hover:bg-[#e00000] transition shadow-md hover:shadow-lg flex items-center justify-center"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Schedule Consultation <FaArrowRight className="ml-2" />
            </motion.button>
            </Link>
          </motion.div>
        </div>
      </section>

      
    </div>
  );
};

export default Home;